import React from 'react';
import BRAND from '../config/brand';

export default function Logo({ size = 32, withText = true }) {
  return (
    <span className="inline-flex items-center gap-2.5 select-none">
      <span
        className="inline-flex items-center justify-center rounded-xl bg-ember shadow-glow-sm"
        style={{ width: size, height: size }}
      >
        <svg width={size * 0.55} height={size * 0.55} viewBox="0 0 24 24" fill="none">
          <path d="M4 6.5C4 5.12 5.12 4 6.5 4h11C18.88 4 20 5.12 20 6.5v7c0 1.38-1.12 2.5-2.5 2.5H12l-4.5 4v-4h-1C5.12 16 4 14.88 4 13.5v-7z" fill="white" />
          <path d="M12 7l1.06 2.44L15.5 10.5l-2.44 1.06L12 14l-1.06-2.44L8.5 10.5l2.44-1.06L12 7z" fill="#FF5A36" />
        </svg>
      </span>
      {withText && <span className="font-heading font-extrabold text-lg tracking-tight text-ink">{BRAND.name}</span>}
    </span>
  );
}
